<template>
    <div class="container">
      <v-card
        class="card"
        :style="{
          width: isMobile ? '100%' : '70%',
          padding: isMobile ? '10px' : '0px',
          height: isMobile ? '700px' : '460px',
          borderRadius: isMobile ? '0px' : '0px',
          marginTop: isMobile ? '0px' : '0px',
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'center'
        }"
        style="
        background-color: #FFFFFF;
        "
        elevation="0"
      >

      <div class="text-section" style="flex: 1;">
          <div
          :style="{
            fontSize: isMobile ? '30px' : '22px',
            fontWeight: isMobile ? '900' : '900',
          }">
            하드웨어 X 시스템 정보
          </div>

            <div
              :style="{
                fontSize: isMobile ? '15px' : '15px',
                fontWeight: isMobile ? '100' : '500',
                paddingTop: '20px',
              }"
            >
              시스템을구성하는 주요 구성장치를 한눈에 확인하세요.
              번거로운 명령어나 불필요한 정보를 입력하지 않아도 시스템 정보를 쉽게 확인할 수 있습니다.
            </div><br>
        </div>
        <div class="image-section" style="flex: 1; display: flex; justify-content: center;">
          <img src="/images/hardware_x/hardware_x_systeminfo.jpg" :width="isMobile ? '500' : '500'">
        </div>
  
      </v-card>
    </div>
  </template>
  
  <script>
  import { useRouter } from 'vue-router';
  import { ref, computed, onMounted } from 'vue';
  
  export default {
    setup() {
      const router = useRouter();
      const isMobile = ref(false);
  
      const checkIsMobile = () => {
        isMobile.value = window.innerWidth <= 768; // Check if the window width is less than or equal to 768px
      };
  
      const goToestimate = () => {
        router.push('/estimate');
      }
  
      onMounted(() => {
        checkIsMobile();
        window.addEventListener('resize', checkIsMobile);
      });
  
      return {
        goToestimate,
        isMobile: computed(() => isMobile.value),
        isDesktop: computed(() => !isMobile.value),
      };
    },
  };
  </script>
  
  <style scoped>
  .container {
    display: flex;
    justify-content: center;
  }
  
  
  
  /* Styles for mobile */
  @media screen and (max-width: 768px) {
    .text-section {
      padding: 0px 20px 0 20px;
    }
  }
  </style>
  